import PropTypes from 'prop-types';
import React from 'react';

export const LossLimitWrapper = ({ softOrder, Component, ...rest }) => {
  const details = {
    tacticName: 'LOSS_LIMIT',
    category: 'Exit',
    type: 'Loss Limit',
    domain: 'Profit/Loss',
  };
  const amount = softOrder.amount;
  const priceToBreak = softOrder.priceToBreak;

  return (
    <Component
      details={details}
      amount={amount}
      priceToBreak={priceToBreak}
      {...rest}
    />
  );
};

LossLimitWrapper.propTypes = {
  Component: PropTypes.any,
  softOrder: PropTypes.shape({
    amount: PropTypes.any,
    priceToBreak: PropTypes.any
  })
};
